import { Component } from '@angular/core';

@Component({
    selector: 'app-thank-you-page',
    templateUrl: './thank-you-page.component.html',
    styleUrls: ['./thank-you-page.component.scss'],
    standalone: false
})
export class ThankYouPageComponent {

}
